module.exports = __webpack_public_path__ + "img/Octocat-waldocat.2da0dd4e.png";